// assets
import { IconDashboard } from 'utils/icons';

// icons
const icons = {
  IconDashboard
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //
// Dashboard je "jádro" (úroveň 1) - viditelný každému přihlášenému bez
// ohledu na roli.
//
// POZOR: 'group-dashboard' se v samotném sidebaru VŮBEC nevykresluje
// (Navigation/index.jsx explicitně filtruje `item.id !== 'group-dashboard'`,
// 2026-08-22 - logo nahoře už je funkční odkaz na dashboard) - tahle data
// existují jen pro PageTitle.jsx/Breadcrumbs.jsx (dohledání názvu/ikony
// aktuální stránky). Docházka (2026-08-23) proto NEPATŘÍ sem, i když sem
// bývala dřív dosazena - byla by stejně neviditelná (real bug odhalený při
// stavbě manažerské akordeon "Docházkový systém") - má vlastní VIDITELNOU
// skupinu, menu-items/attendance.jsx.

export function buildDashboardMenu(user) {
  return {
    id: 'group-dashboard',
    title: 'Navigation',
    type: 'group',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        url: '/dashboard/default',
        icon: icons.IconDashboard,
        breadcrumbs: false
      }
    ]
  };
}

const dashboard = buildDashboardMenu(null);

export default dashboard;
